// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"fees_errorMessage__3KuSb","Title":"fees_Title__2Lv8s"};